module.exports = __webpack_public_path__ + "img/weChatShare.1df65a78.jpg";